<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <h4 class="page-title">Dashboard</h4>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 col-xl-4">
                <router-link :to="{name: 'sesLandHouseReportPackageA'}" tag="a" >
                    <div class="p-2 text-center card-box">
                        <h3><span><span>{{ this.A }}</span></span>
                        </h3>
                        <p class="text-muted font-15 mb-0">A</p>
                    </div>
                </router-link>
            </div>
            <div class="col-md-6 col-xl-4">
                <router-link :to="{name: 'sesLandHouseReportPackageB'}" tag="a" >
                    <div class="p-2 text-center card-box">
                        <h3><span><span>{{ this.B }}</span></span>
                        </h3>
                        <p class="text-muted font-15 mb-0">B</p>
                    </div>
                </router-link>
            </div>
            <div class="col-md-6 col-xl-4">
                <router-link :to="{name: 'sesLandHouseReportPackageAB'}" tag="a" >
                    <div class="p-2 text-center card-box">
                        <h3><span><span>{{ this.A + this.B }}</span></span>
                        </h3>
                        <p class="text-muted font-15 mb-0">Total (A B) </p>
                    </div>
                </router-link>
            </div>
        </div>
     
        <div class="row">
            <div class="col-md-6 col-sm-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mb-4">House Report by Package</h4>
                        <!-- Bar Chart -->
                        <resettlementsHousePackageChart :height="350"/>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import http from "@state/http";
    import store from "../../../../state/store";
    import resettlementsHousePackageChart from '../chart/resettlementsHousePackageChart.vue'
   import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,
        page: {
            title: "Dashboard",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {
            Layout,
            resettlementsHousePackageChart
        },
        data() {
            return {
                title: "Dashboard",
                items: [
                    {
                        text: "DORP",
                        href: "/"
                    },
                    {
                        text: "Dashboard",
                        active: true
                    }
                ],

                A: "",
                B: "",
                endVal: 0
            };
        },
        mounted() {
            this.packagesReport()
        },
        methods: {
            packagesReport() {
                http.post("api/ses/land/house/report/package").then(response => {
                    if (!response.error) {
                        var A=0;
                        var B=0;
                        for(var i = 0; i < response.data.houses.length; i++){
                            A += parseInt(response.data.houses[i].A)
                            B += parseInt(response.data.houses[i].B)
                        }
                    }
                    this.A = A;
                    this.B = B;
                });
            },
        },
    };
</script>
